import { Box } from "@mui/material";
import { SideBar } from "components/SideBar";
import { routes } from "config/routes";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { checkRoute } from "utils/checkRoute";
import { setPageType } from "features/CompanyGroups/CompanyGroupsActions";
import { localStorageManager } from "lib/localStorageManager";
import { useTypedDispatch } from "store";
import Helmet from "react-helmet";
import { AssistantChatLayout } from "../AssistantChatLayout/AssistantChatLayout";
import { getLayoutContentMaxWidth } from "./getLayoutContentMaxWidth";

export const Layout = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const dispatch = useTypedDispatch();

  useEffect(() => {
    const isGeneralRoute = checkRoute(location.pathname, routes);
    if (isGeneralRoute) localStorageManager.clearStorage();
    const token = localStorageManager.getToken();
    dispatch(setPageType(!!token));
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Box
      sx={{
        display: "flex",
      }}
    >
      <Helmet>
        <script
          src="https://cdn.platform.openai.com/deployments/chatkit/chatkit.js"
          async
        />
      </Helmet>
      <SideBar />
      <Box
        sx={{
          width: "100%",
          overflow: "auto",
          maxWidth: getLayoutContentMaxWidth(location.pathname),
        }}
      >
        {children}
        <AssistantChatLayout />
      </Box>
    </Box>
  );
};
